// used for cards in the tree
const SIMPLE_ANALYSIS_TYPE = 'SimpleAnalysisType';
const CALCULATED_ANALYSIS_TYPE = 'CalculatedAnalysisType';
const WATER_CONSUMPTION_ANALYSIS_TYPE = 'WaterConsumptionAnalysisType';
const PRODUCT_CONSUMPTION_ANALYSIS_TYPE = 'ProductConsumptionAnalysisType';
const FLOW_METER_ANALYSIS_TYPE = 'FlowMeterAnalysisType';
// not shown in the tree
const TYPE_CORROSION = 'CorrosionAnalysisType';
const TYPE_LEGIONELLA = 'LegionellaAnalysisType';
const TYPE_COMPOSITION = 'CompositionAnalysisType';
const TYPE_TEXT = 'TextAnalysisType';
const TYPE_LIST = 'ListAnalysisType';
const FUEL_CONSUMPTION_ANALYSIS_TYPE = 'FuelConsumptionAnalysisType';
// templates
const STANDARD_TEMPLATE = 'standard';
const CUSTOM_TEMPLATE = 'custom';

const TYPES = [
    SIMPLE_ANALYSIS_TYPE,
    CALCULATED_ANALYSIS_TYPE,
    WATER_CONSUMPTION_ANALYSIS_TYPE,
    PRODUCT_CONSUMPTION_ANALYSIS_TYPE,
    TYPE_CORROSION,
    TYPE_LEGIONELLA,
    TYPE_COMPOSITION,
    TYPE_TEXT,
    TYPE_LIST,
    FUEL_CONSUMPTION_ANALYSIS_TYPE,
    FLOW_METER_ANALYSIS_TYPE,
];

const analysisConfiguration = {
    [SIMPLE_ANALYSIS_TYPE]: {
        color: 'primary',
    },
    [CALCULATED_ANALYSIS_TYPE]: {
        color: '#7EB0BF',
    },
    [WATER_CONSUMPTION_ANALYSIS_TYPE]: {
        color: '#157362',
    },
    [PRODUCT_CONSUMPTION_ANALYSIS_TYPE]: {
        color: '#48a174',
    },
    [FUEL_CONSUMPTION_ANALYSIS_TYPE]: {
        color: '#9F2C41',
    },
    [FLOW_METER_ANALYSIS_TYPE]: {
        color: '#0d6382',
    },
};

module.exports = {
    TYPES,
    TYPE_CORROSION,
    TYPE_LEGIONELLA,
    TYPE_COMPOSITION,
    TYPE_TEXT,
    TYPE_LIST,
    FUEL_CONSUMPTION_ANALYSIS_TYPE,
    SIMPLE_ANALYSIS_TYPE,
    CALCULATED_ANALYSIS_TYPE,
    WATER_CONSUMPTION_ANALYSIS_TYPE,
    PRODUCT_CONSUMPTION_ANALYSIS_TYPE,
    STANDARD_TEMPLATE,
    CUSTOM_TEMPLATE,
    analysisConfiguration,
    FLOW_METER_ANALYSIS_TYPE,
};

